/* eslint-disable comma-dangle */
import api from '@/api';
import {
  BAD_REQUEST,
  CONFLICT,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY
} from '../../enums/errorEnums';

const baseAPI = process.env.VUE_APP_BASE_API;

const HANDLED_ERRORS = [
  NOT_ACCEPTABLE,
  CONFLICT,
  UNPROCESSABLE_ENTITY,
  UNAUTHORIZED,
  NOT_FOUND,
  BAD_REQUEST,
];

export default {
  login: async ({ email, password, isCompany }) => {
    try {
      const response = await api.post(`${baseAPI}/Authentication/login`, {
        email: email.toLowerCase(),
        password,
        isCompany,
      });

      let errors = null;
      const { status } = response;

      if (HANDLED_ERRORS.includes(status)) {
        errors = {
          status,
          statusText: response.data.message || response.statusText,
        };
      }

      const { data } = response;

      return {
        data,
        errors,
      };
    } catch (error) {
      return {
        errors: {
          status: 0,
          statusText: 'Ocorreu um erro ao fazer login',
        },
      };
    }
  },
  resetPassword: async ({ email }) => {
    try {
      const response = await api.post(`${baseAPI}/Authentication/reset-password`, {
        email: email.toLowerCase(),
      });

      let errors = null;
      const { status } = response;

      if (HANDLED_ERRORS.includes(status)) {
        errors = {
          status,
          statusText: response.statusText || response.data.message,
        };
      }

      const { data } = response;

      return {
        data,
        errors,
      };
    } catch (error) {
      return {
        errors: {
          status: 0,
          statusText: 'Ocorreu um erro ao enviar a solicitação de redefinição de senha',
        },
      };
    }
  },
  validateToken: async ({ token }) => {
    try {
      const response = await api.post(`${baseAPI}/Authentication/validate-token`, {
        token,
      });

      let errors = null;
      const { status } = response;

      if (HANDLED_ERRORS.includes(status)) {
        errors = {
          status,
          statusText: response.statusText || response.data.message,
        };
      }

      const { data } = response;

      return {
        data,
        errors,
      };
    } catch (error) {
      return {
        errors: {
          status: 0,
          statusText: 'Ocorreu um erro ao validar o token',
        },
      };
    }
  },
  changePassword: async ({ password, token }) => {
    try {
      const response = await api.post(`${baseAPI}/Authentication/change-password`, {
        password,
        token,
      });

      let errors = null;
      const { status } = response;

      if (HANDLED_ERRORS.includes(status)) {
        errors = {
          status,
          statusText: response.statusText || response.data.message,
        };
      }

      const { data } = response;

      return {
        data,
        errors,
      };
    } catch (error) {
      return {
        errors: {
          status: 0,
          statusText: 'Ocorreu um erro ao redefinir sua senha',
        },
      };
    }
  },
};
